export const INTRO_CONSTANTS = {
  title:
    "Engineered for Always-On Performance — \n Scalable Internet & Interconnect by OneMind",
  text: "OneMind delivers enterprise-grade connectivity with carrier-neutral design, automated redundancy, and zero vendor lock-in — empowering businesses with a cloud-first backbone that’s built for resilience and speed. ",
};
